import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NumberingMustNotBeEmptyError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.numbering-must-not-be-empty-error');
    }
}
